<template>
    <div>
        <div class="p_title container bottomline mt30">
            <div class="titlebox fleft mt20">
                <h5>加入我们</h5>
                <p>Join Us</p>
            </div>
            <ul class="titlemenu fright mt50">
                <li><router-link :to="{path:'/job/info',query:{pid:pidlinian}}">用人理念</router-link></li>
                <li class="active"><router-link :to="{path:'/job/care/list',query:{pid:pidemployeecare}}">员工关爱</router-link></li>
                <li><router-link :to="{path:'/job/find/list',query:{pid:pidemployment}}">招聘信息</router-link></li>
            </ul>
        </div>
        <div class="p_body container mt50">
            <div class="p_body_content">
                <div class="p_body_content_title fontbold">
                    <h5 class="body_info_title">{{itemData.title}}</h5>
                </div>
                <div class="p_body_content_stuff mt20" v-html="itemData.content"></div>
            </div>
        </div>
    </div>
</template>


<script>

import configration from '@/tools/js/enumconfig'

export default {
    data(){
        return {
            totleCount:0,
            itemData:{},
 
            id:'',
            pid:'',
            showtitle:'员工关爱',
            imgbaseurl : this.$baseURL.fileurl,
            
            pidemployeecare:configration.config.enum.pidemployeecare,
            pidemployment:configration.config.enum.pidemployment,
            pidlinian:configration.config.enum.pidlinian,

        }
    },
     methods:{
        getData:function(id){
            let vm = this;
           
            vm.$httpi.get('/api/v1/articles/doc/getitem?id='+id)
            .then(function (response) {
                if(response != null && response.data.success){
                    vm.itemData = response.data.data;
                    vm.showtitle = vm.itemData.title;
                }
            });
        },


        gotolist(pid){
            const vm = this;
            vm.$router.push({path:'/job/care/list',query:{pid:pid}});
        },
        initpage(){
            let vm = this;
            //绑定
            if(vm.$route.query.id!=undefined && vm.$route.query.id.length>0)
            {
                vm.id = vm.$route.query.id;
                vm.getData(vm.$route.query.id);
            }
            if(vm.$route.query.pid!=undefined && vm.$route.query.pid.length>0)
            {
                vm.pid = vm.$route.query.pid;
            }
        }
     },
     mounted() {
        let vm = this;
        //绑定
        vm.initpage();
    }
}
</script>

